import type { IRecord, IRecordTypeDefinition } from '@platform/core/types';
import { valueOf } from './valueOf';

/** Найбільша довжина короткого тексту (UIUX forms/validation, field-types/short-text). */
export const TEXT_MAX = 255;

/**
 * Перевірка чернетки перед збереженням (UIUX forms/validation: «недійсні значення не зберігаються»): обов'язкові поля (назва — якщо
 * не формується автоматично), числа, довжина короткого тексту. Повертає ключ поля → код помилки (required · number · tooLong).
 * Перевіряються лише поля, які змінює чернетка, і обов'язкові (порожнє обов'язкове — якщо його змінено або `all`: новий запис). Чиста функція.
 */
export function validateDraft(rt: Pick<IRecordTypeDefinition, 'fields' | 'titleAuto'>, record: IRecord | undefined, draft: Record<string, unknown>, all = false): Record<string, 'required' | 'number' | 'tooLong'> {
  const errors: Record<string, 'required' | 'number' | 'tooLong'> = {};
  for (const f of rt.fields) {
    const changed = f.key in draft;
    const value = valueOf(record, draft, f.key);
    const empty = value === null || value === undefined || (typeof value === 'string' && !value.trim()) || (Array.isArray(value) && !value.length);
    const required = f.key === 'title' ? !rt.titleAuto : Boolean(f.required);
    if (required && empty && (all || changed || f.key === 'title')) { errors[f.key] = 'required'; continue; }
    if (!changed || empty) continue;
    if (f.type === 'number' && Number.isNaN(Number(value))) errors[f.key] = 'number';
    else if (f.type === 'text' && typeof value === 'string' && value.length > TEXT_MAX) errors[f.key] = 'tooLong';
  }
  return errors;
}
